var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import HotList from './hotList';
import { h5PageCount } from '../../../utils';
import { getHotList } from '../utils/api';
import { WxLaunchApp } from '../../wxLaunchApp';
const { callApp, getSchemeLink, getWebAppLink } = require('@ifeng-fe/callapp');
class ShareComment extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            hotListData: {
                count: 0,
                join_count: 0,
                comments: [],
                allow_comment: -1,
            },
        };
        this.handleClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
            const { articleInfo: { id, _id, docUrl, clickCount, kind, callType, topicId, downloads = {}, others = {}, isVideoShare, noKindFrom = 0, }, } = this.props;
            const NoUcmsPrefix = ['topic2', 'hotspotlist', 'survey', 'customPage'];
            const nodata = '';
            const doc_type = callType || 'doc';
            const aid = !~NoUcmsPrefix.indexOf(callType || '') ? _id || id : topicId;
            const to_url = docUrl;
            const client = isVideoShare ? 'videoApp' : 'newsApp';
            if (clickCount && isSendCount) {
                h5PageCount([clickCount]);
            }
            if (isJumpQQlink) {
                if (clickCount) {
                    clickCount.other.tag = 't9';
                    h5PageCount([clickCount]);
                }
                const gourl = (downloads && downloads.download) || '';
            }
            if (isCallApp) {
                callApp({
                    client,
                    docType: doc_type,
                    pid: aid,
                    hasComment: 1,
                    kind,
                    noKindFrom,
                    download: downloads.download,
                    downloadAd: downloads.downloadAd,
                    isCopySchemeUrl: isJumpQQlink,
                });
            }
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { articleInfo } = this.props;
            const { cmtNumUrl, docUrl, skey, hotLimit } = articleInfo;
            try {
                const hotListData = yield getHotList(cmtNumUrl, docUrl, skey, hotLimit);
                this.setState({
                    hotListData,
                });
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    render() {
        const { hotListData } = this.state;
        const { articleInfo: { isVideoShare, callType, topicId, id, _id, kind, wxLaunchType, wxLaunchSwitch, weappLink }, } = this.props;
        const NoUcmsPrefix = ['topic2', 'hotspotlist', 'survey', 'customPage'];
        const aid = !~NoUcmsPrefix.indexOf(callType || '') ? _id || id : topicId;
        const schemeLink = wxLaunchType === 'weapp'
            ? weappLink ||
                getWebAppLink({
                    docType: callType || 'doc',
                    pid: aid,
                })
            : getSchemeLink({
                docType: callType || 'doc',
                pid: aid,
                kind,
            });
        const wxLaunchConfig = {
            isVideoShare,
            wxLaunchType,
            wxLaunchSwitch,
            schemeLink,
        };
        if (hotListData.allow_comment === -1)
            return null;
        return (React.createElement("div", { className: styles.comment_box },
            hotListData && hotListData.comments && hotListData.comments.length > 0 && (React.createElement("div", null,
                React.createElement("div", { className: styles.title_box },
                    React.createElement("div", { className: styles.title },
                        React.createElement("span", null),
                        React.createElement("a", null, "\u70ED\u95E8\u8BC4\u8BBA"))),
                React.createElement("div", null,
                    React.createElement(HotList, { content: hotListData.comments, wxLaunchConfig: wxLaunchConfig, handleCallNewsApp: this.handleClick })))),
            React.createElement("div", { className: styles.more_box, onClick: this.handleClick },
                React.createElement("div", { className: styles.more },
                    !isVideoShare && React.createElement("span", null, "\u6253\u5F00\u51E4\u51F0\u65B0\u95FB\uFF0C\u67E5\u770B\u66F4\u591A\u8BC4\u8BBA"),
                    isVideoShare && React.createElement("span", null, "\u6253\u5F00\u51E4\u51F0\u89C6\u9891\uFF0C\u67E5\u770B\u66F4\u591A\u8BC4\u8BBA")),
                !isVideoShare && wxLaunchSwitch && (React.createElement(WxLaunchApp, { launchType: wxLaunchType, schemeLink: schemeLink, launchAppClick: this.handleClick.bind(this, true, false, false), launchAppFail: this.handleClick.bind(this, false, true, true) })))));
    }
}
ShareComment.defaultProps = {
    articleInfo: {
        cmtLength: 1000,
        hotLimit: 2,
    },
};
export default ShareComment;
